//
//
//
//
//
//
//
//
//
//


import IconMixin from "./IconMixin";

export default {
    name: 'Icon',

    mixins: [IconMixin],

    props: {

        // The name of the icon to show
        icon: {
            type: String,
            required: true
        },

        // Whether to center the icon
        center: {
            type: Boolean,
            default: false
        },

        // Whether the icon size shall be forced so it can not be overwritten by other stylings
        forceSize: {
            type: Boolean,
            default: false
        },

        // Whether the icon shall retrieve a light background
        prominent: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        computedSize() {
            switch (this.sizeString) {
                case '2xs':
                    return 14;
                case 'xs':
                    return 16;
                case 'sm':
                    return 20;
                case 'lg':
                    return 28;
                case 'xl':
                    return 32;
                case '2xl':
                    return 36;
            }

            return this.size;
        },

        iconStyle() {
            const style = {}
            if (this.forceSize || this.prominent) {
                style.width = this.computedSize + 'px';
                style.height = this.computedSize + 'px';
            }
            if (this.colorHex) {
                style.color = this.colorHex;
            }

            return style;
        }
    }
}
